<div id="master">
    <div id="top-menu">
        <div id="clients-menu-item" class="top-menu-item">
            <a routerLink="/clients">Klienci</a>
        </div>
        <div id="instances-menu-item" class="top-menu-item">
            <a routerLink="/instances">Instancje</a>
        </div>
        <div id="logout-menu-item" class="top-menu-item">
            <a (click)="logOut()">Wyloguj</a>
        </div>
    </div>
    <div id="content">
        <router-outlet></router-outlet>
    </div>
</div>